var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_157463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 18.3332C7.96056 18.3332 8.33366 17.9601 8.33366 17.4998C8.33366 17.0396 7.96056 16.6665 7.50033 16.6665C7.04009 16.6665 6.66699 17.0396 6.66699 17.4998C6.66699 17.9601 7.04009 18.3332 7.50033 18.3332Z",
    stroke: "#313133",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 18.3332C17.1266 18.3332 17.4997 17.9601 17.4997 17.4998C17.4997 17.0396 17.1266 16.6665 16.6663 16.6665C16.2061 16.6665 15.833 17.0396 15.833 17.4998C15.833 17.9601 16.2061 18.3332 16.6663 18.3332Z",
    stroke: "#313133",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 0.833496H4.16634L6.39967 11.9918C6.47588 12.3755 6.6846 12.7201 6.9893 12.9654C7.29399 13.2107 7.67526 13.341 8.06634 13.3335H16.1663C16.5574 13.341 16.9387 13.2107 17.2434 12.9654C17.5481 12.7201 17.7568 12.3755 17.833 11.9918L19.1663 5.00016H4.99967",
    stroke: "#313133",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_157463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.91081b60edbcedd3f28388b30d542769.svg";
export { ForwardRef as ReactComponent };